module.exports = function (fox) {
	'use strict';

	require('./widget/consent')(fox, fox.jQuery);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/consent/index.js
// module id = 611
// module chunks = 2